import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import $ from "jquery";
import Popper from "popper.js";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "../assets/css/icons.css";
import "../assets/css/style.css";
import ralogo from "../assets/images/RemoteAssist.png";
import user_img from "../assets/images/user/user.svg";
import logo from "../assets/images/logo_white.svg";
import {
  SERVER_IP,
  PORT,
  jwt,
  ud,
  auth_response_flow,
  changeUserInfo,
  Communication_obj,
  Security,
  LICENSE,
} from "../Server";
import { GetLiveUsers } from "../SocketData";
import axios from "axios";
import SelectUsers from "../FormController/VideoChat/AddUsersToCall";
import { NavLink } from "react-router-dom";
import {
  AssignedWorkflowIcon,
  CallIcon,
  CallPLusIcon,
  DashboardIcon,
  ReportIcon,
  UserIcon,
  VideoIcon,
} from "../assets/Icons";

var socket;
var simulanisimg = ud && ud.cooperate_logo ? ud.cooperate_logo : user_img;

class LeftNavBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showChats: Communication_obj,
      server: `${SERVER_IP}`,
      user_list: [],
      calling: false,
      calling_mode: "",
      socket_id: "",
      room_id: "0",
      userArrObj: [],
      select_user_popup: false,
      webgl_token: "",
    };
  }
  componentWillReceiveProps(props) {
    if (socket === undefined) {
      if (props.socket) {
        this.connectToSocket(props.socket);
      }
    }
  }
  componentDidMount() {
    var webgl_token = sessionStorage.getItem("webgl_token");
    this.setState({ webgl_token: webgl_token });
    if (ud.usertype != 0) {
      if (Security) {
        setTimeout(() => this.userSessionUpdate(), 2000);
        setInterval(() => this.userSessionUpdate(), 15000);
      }
    }

    $(".xp-vertical-menu li").on("click", function () {
      $(this).siblings().removeClass("active");
      $(this).addClass("active");
    });

    if (this.state.showChats) {
      this.connectToSocket(this.props.socket);
    }
    this.dataByLicense();
  }
  dataByLicense = () => {
    if (LICENSE.application_Dashboard) {
      this.setState(this.state);
    } else {
      setTimeout(() => {
        this.dataByLicense();
      }, 1000);
    }
  };
  //Date Format 2022-07-27
  formatDate = (date) => {
    let d = new Date(date);
    let month = (d.getMonth() + 1).toString();
    let day = d.getDate().toString();
    let year = d.getFullYear();
    if (month.length < 2) {
      month = "0" + month;
    }
    if (day.length < 2) {
      day = "0" + day;
    }
    return [year, month, day].join("-");
  };
  userSessionUpdate = () => {
    var reqData = {
      session_id: ud.session_id,
    };
    let headers = {
      user_id: ud.id.toString(),
      session_id: ud.session_id.toString(),
      user_type: ud.usertype.toString(),
      main_id: ud.main_id.toString(),
      jwt_token: jwt,
      c_id: ud.c_id.toString(),
    };
    let _this = this;
    axios
      .post(`${SERVER_IP}/usersUserSessionUpdate`, reqData, { withCredentials: true, headers: headers })
      .then(function (response) {
        if (response.data.error) {
          auth_response_flow(response.data, (return_response) => {
            if (return_response.error === false && return_response.retry === true) {
              _this.userSessionUpdate();
            }
          });
        }
      })
      .catch(function (error) {
        // swal("Something Went Wrong,Please Retry")
      });
  };
  connectToSocket = (socketinfo) => {
    socket = socketinfo;
    if (socket) {
      this.LiveUserList();
    }
  };
  LiveUserList = () => {
    var _this = this;

    setTimeout(() => {
      GetLiveUsers((ActiveUsers) => {
        _this.setState({ user_list: ActiveUsers });
      });
    }, 2000);

    socket.on("live_users_list", function (data) {
      if (data.data === "NEW") {
        if (_this.state.user_list.find((raw) => raw.user_id == data.liveusers[0].user_id)) {
          // do nothing...
        } else {
          _this.state.user_list.push(data.liveusers[0]);
          _this.setState(_this.state);
        }
      } else if (data.data === "ALL") {
        _this.setState({ user_list: data.liveusers });
      } else if (data.data === "DELETE") {
        var del_obj = _this.state.user_list.findIndex((x) => x.user_id === data.liveusers[0].user_id);
        if (del_obj > -1) {
          _this.state.user_list.splice(del_obj, 1);
          _this.setState(_this.state);
        }
      } else if (data.data === "UPDATE") {
        var del_obj = _this.state.user_list.findIndex((x) => x.user_id === data.liveusers[0].user_id);
        if (del_obj > -1) {
          _this.state.user_list[del_obj] = data.liveusers[0];
          _this.setState(_this.state);
        }
      }
    });
    // var _this = this;
    // _this.emit_I_AM_ONLINE();

    // socket.on('reconnect', function () {
    //     _this.emit_I_AM_ONLINE();
    // })
  };
  emit_I_AM_ONLINE = () => {
    var json_data = {
      user_id: ud.id,
      session_id: ud.session_id,
      receive_data: true,
      datetime: this.formatDate(new Date()) + " " + new Date().toLocaleTimeString(),
    };
    socket.emit("i_am_online", json_data);
  };
  listTypeClick = () => {
    window.location.href = "/create/listtypes";
  };
  hierarchyTypeClick = () => {
    window.location.href = "/create/typehierarchy";
  };
  callInitiation = (call_type, call_format, callers) => {
    let to_calling_obj;
    if (Array.isArray(callers)) {
      to_calling_obj = { call_type, call_format, callers };
    } else {
      to_calling_obj = { call_type, call_format, callers: [callers] };
    }
    this.props.toCalling(to_calling_obj);
  };
  // closePopup = () => {
  //     this.setState({ calling: false, room_id: "0" })
  //     sessionStorage.removeItem('call_room');
  // }
  openUserPopup = () => {
    var arrObj = [];
    this.state.user_list.map((list, index) => {
      if (list.user_id != ud.id) {
        arrObj.push({ value: JSON.stringify(list), label: `${list.user_name}` });
      }
    });
    this.setState({ select_user_popup: true, userArrObj: arrObj });
  };
  selectedUserForCall = (user_list) => {
    this.callInitiation("INITIATE", "F_VIDEO_CALL", user_list);
    this.setState({ select_user_popup: false });
  };
  closeUserCallPopup = () => {
    this.setState({ select_user_popup: false });
  };

  // sideclose
  vmenuclose() {
    document.getElementsByClassName("xp-leftbar")[0].style.display = "none";
  }
  render() {
    if (ud) {
      // 1 ===> Simulanis Admin
      if (ud.usertype === 0) {
      // if (true) {
        return (
          <div>
            <div className="xp-leftbar">
              <div className="xp-sidebar">
                <div className="xp-logobar text-center">
                  <a className="xp-logo pl-2">
                    <span className="logoimg">
                      <img src={ralogo} className="img-fluid" alt="logo" />{" "}
                    </span>{" "}
                    <span className="logoname">Remote Assist</span>{" "}
                  </a>
                  <span className="sideclose d-block d-md-none" onClick={this.vmenuclose}>
                    <i className="fa fa-times"></i>
                  </span>
                </div>

                <div className="xp-navigationbar">
                  <ul className="xp-vertical-menu">
                    <li>
                      <NavLink to="/dashboard">
                        <i className="icon-speedometer"></i>
                        <span>Dashboard</span>
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to="/create/listcadmin">
                        <i className="icon-speedometer"></i>
                        <span>Corporate Admin</span>
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to="/create/listlocation">
                        <i className="icon-speedometer"></i>
                        <span>Locations</span>
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to="/create/config">
                        <i className="icon-speedometer"></i>
                        <span>Configuration</span>
                      </NavLink>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        );
      }

      // 1 ===> C_Admin
      else if (ud.usertype === 1) {
        // else if (true) {
        return (
          <div>
            <div className="xp-leftbar">
              <div className="xp-sidebar">
                <div className="xp-logobar text-center">
                  <a className="xp-logo pl-2">
                    <span className="logoimg">
                      <img src={ralogo} className="img-fluid" alt="logo" />{" "}
                    </span>{" "}
                    <span className="logoname">Remote Assist</span>{" "}
                  </a>
                  <span className="sideclose d-block d-md-none" onClick={this.vmenuclose}>
                    <i className="fa fa-times"></i>
                  </span>
                </div>

                <div className="xp-navigationbar">
                  <ul className="xp-vertical-menu">
                    <li>
                      <NavLink activeClassName="active" to="/dashboard">
                        <i className="icon-speedometer"></i>
                        <span>Dashboard</span>
                      </NavLink>
                    </li>
                    <li>
                      <NavLink activeClassName="active" to="/create/listsadmin">
                        <i className="icon-social-dropbox"></i>
                        <span>Site Admin</span>
                      </NavLink>
                    </li>
                    <li>
                      <NavLink activeClassName="active" to="/create/listcadmin">
                        <i className="icon-speedometer"></i>
                        <span>Corporate Admin</span>
                      </NavLink>
                    </li>
                    <li>
                      <NavLink activeClassName="active" to="/create/listlocation">
                        <i className="fa fa-location-arrow"></i>
                        <span>Locations</span>
                      </NavLink>
                    </li>
                    <li>
                      <NavLink activeClassName="active" to="/create/corporatelogo">
                        <i className="fa fa-briefcase"></i>
                        <span>Corporate Logo</span>
                      </NavLink>
                    </li>
                    {/* <li>
                                            <a >
                                                <i className="icon-layers"></i><span>Organizational Structures</span><i className="icon-arrow-right pull-right"></i>
                                            </a>
                                            <ul className="xp-vertical-submenu">
                                                <li><a onClick={this.listTypeClick}>Create Structure</a></li>
                                                <li><a onClick={this.hierarchyTypeClick}>All Structures</a></li>
                                            </ul>
                                        </li> */}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        );
      }
      // 1 ===> s_Admin
      else if (ud.usertype === 2) {
        // else if (true) {
        return (
          <div>
            <div className="xp-leftbar">
              <div className="xp-sidebar">
                <div className="xp-logobar text-center">
                  <a className="xp-logo">
                    <span className="logoimg">
                      <img src={ralogo} className="img-fluid" alt="logo" />{" "}
                    </span>{" "}
                    <span className="logoname">Remote Assist</span>{" "}
                  </a>
                  <span className="sideclose d-block d-md-none" onClick={this.vmenuclose}>
                    <i className="fa fa-times"></i>
                  </span>
                </div>

                <div className="xp-navigationbar">
                  <ul className="xp-vertical-menu">
                    <li>
                      <NavLink to="/dashboard">
                        <i>
                          <DashboardIcon />
                        </i>
                        <span>Dashboard</span>
                      </NavLink>
                    </li>
                    {/* <li>
                      <NavLink to="/create/listsadmin">
                        <i className="icon-social-dropbox"></i>
                        <span>Site Admin</span>
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to="/create/listuser">
                        <i className="icon-social-dropbox"></i>
                        <span>Users</span>
                      </NavLink>
                    </li> */}

                    {/* <li>
                      <a onClick={this.hierarchyTypeClick}>
                        <i className="icon-layers"></i>
                        <span>Organizational Structures</span>
                      </a>
                      <ul className="xp-vertical-submenu">
                                                <li><a onClick={this.listTypeClick}>Create Structure</a></li>
                                                <li><a onClick={this.hierarchyTypeClick}>All Structures</a></li>
                                            </ul>
                    </li> */}

                    {/* {LICENSE.workflow ? (
                      Object.keys(LICENSE.workflow).length > 1 ? ( */}
                    <li>
                      <NavLink to="/create/workflow">
                        <i>
                          <AssignedWorkflowIcon />{" "}
                        </i>
                        <span>Workflow</span>
                      </NavLink>
                    </li>
                    {/* ) : null
                    ) : null} */}

                    <li>
                      <NavLink to="/create/userlistreport">
                        <i>
                          <ReportIcon />
                        </i>
                        <span>Reports</span>
                      </NavLink>
                    </li>
                    <li>
                      <a>
                        <i>
                          <CallIcon />
                        </i>
                        <span>Library</span>
                        {/* <i className="icon-arrow-right pull-right"></i> */}
                      </a>
                      {/* <ul className="xp-vertical-submenu">
                        <li>
                          <a onClick={() => (window.location.href = "/create/mcqbanklist")}>MCQ</a>
                        </li>
                        <li>
                          <a onClick={() => (window.location.href = "/create/rangebanklist")}>Range</a>
                        </li>
                        <li>
                          <a onClick={() => (window.location.href = "/create/parentchildbanklist")}>
                            Question Hierarchy
                          </a>
                        </li>
                      </ul> */}
                    </li>
                    <li>
                      <NavLink to="/create/listsop">
                        <i>
                          <VideoIcon />
                        </i>
                        <span>Workflow Type</span>
                      </NavLink>
                    </li>
                    {/* <li>
                      <NavLink to="/create/faq">
                        <i className="fa fa-question"></i>
                        <span>FAQ</span>
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to="/create/trash">
                        <i className="fa-solid fa-trash"></i>
                        <span>Trash</span>
                      </NavLink>
                    </li> */}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        );
      }
      // 1 ===> user
      else if (ud.usertype === 3) {
        return (
          <div>
            <div className="xp-leftbar">
              <div className="xp-sidebar">
                <div className="xp-logobar pt-3">
                  <a className="xp-logo pl-2">
                    <span className="logoimg">
                      <img src={ralogo} className="img-fluid" alt="logo" />{" "}
                    </span>{" "}
                    <span className="logoname">Remote Assist</span>{" "}
                  </a>
                  <span className="sideclose d-block d-md-none" onClick={this.vmenuclose}>
                    <i className="fa fa-times"></i>
                  </span>
                </div>
                <div className="xp-navigationbar">
                  <ul className="xp-vertical-menu">
                    <li>
                      <NavLink to="/new-call">
                        <i>
                          <CallPLusIcon />
                        </i>
                        <span>New Call</span>
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to="/dashboard">
                        <i>
                          <DashboardIcon />
                        </i>
                        <span>Dashboard</span>
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to="/create/alignedworkflow">
                        <i>
                          <AssignedWorkflowIcon />
                        </i>
                        <span>Assigned Workflow</span>
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to="/create/callstaistics" onClick={() => sessionStorage.removeItem("call_staistics")}>
                        <i>
                          <CallIcon />
                        </i>
                        <span>Call Logs</span>
                      </NavLink>
                    </li>
                    <li className="inactive">
                      <a className="greyout">
                        <i>
                          <VideoIcon />{" "}
                        </i>
                        <span>Video Call Logs</span>
                      </a>
                    </li>
                    <li className="inactive">
                      <a className="greyout">
                        <i>
                          <ReportIcon />
                        </i>
                        <span>My Reports</span>
                      </a>
                    </li>
                  </ul>
                </div>

                <div className="xp-sidebar" style={{ display: this.state.showChats ? "block" : "none" }}>
                  {/* <ul className="xp-vertical-menu">
                                        <li className="position-relative">
                                            <a>
                                                <i className="icon-speedometer"></i><span>Live User</span>

                                            </a>

                                            <button type="button" className="add_user-call" title="Add user" onClick={this.openUserPopup}><i className="mdi mdi-plus"></i></button>
                                        </li>
                                    </ul> */}
                  {this.state.select_user_popup ? (
                    <SelectUsers
                      options={this.state.userArrObj}
                      selectedUsers={this.selectedUserForCall}
                      closeUserCallPopup={this.closeUserCallPopup}
                    />
                  ) : null}
                  <ul className="xp-vertical-menu live_user-list">
                    {this.state.user_list.map((list) =>
                      list.user_id == ud.id ? null : (
                        <li>
                          <a>
                            <div className="item">
                              <div className="user_live">
                                <div className="u-holder">
                                  <img src={`${SERVER_IP}/icons/${list.profile_picture}`} />
                                </div>
                                {list.chat_status == 1 ? (
                                  <span className="v_status s-live" data-toggle="tooltip" title="Online"></span>
                                ) : (
                                  <span className="v_status s-busy" data-toggle="tooltip" title="Busy">
                                    <i className="mdi mdi-timer-sand"></i>
                                  </span>
                                )}
                                {/* <span className="v_status s-busy" data-toggle="tooltip" title="Busy"><i className="mdi mdi-timer-sand"></i></span> */}
                                {/* <span className="v_status s-dnd" data-toggle="tooltip" title="DND"><i className="fa fa-ban"></i></span> */}
                              </div>
                              <span>{list.user_name}</span>
                            </div>
                            <div className="vid-icon">
                              {/* <button type="button" class="btn btn-round btn-secondary  ml-2" data-toggle="tooltip" title="Video call" onClick={() => this.callInitiation("INITIATE", "F_VIDEO_CALL", list)}><i class="mdi mdi-video"></i> </button> */}
                              <button
                                type="button"
                                class="btn btn-round btn-success ml-2"
                                data-toggle="tooltip"
                                title="Audio call"
                                onClick={() => this.callInitiation("INITIATE", "F_AUDIO_CALL", list)}
                              >
                                <i class="mdi mdi-phone"></i>{" "}
                              </button>
                            </div>
                          </a>
                        </li>
                      )
                    )}
                  </ul>
                  {/* {this.state.calling ?
                                        <CallInitiation calling_mode={this.state.calling_mode} callError={this.closePopup} room_id={this.state.room_id} />
                                        : null} */}
                </div>
              </div>
            </div>
          </div>
        );
      }
    } else {
      return <div></div>;
    }
  }
}
export default LeftNavBar;
